/* eslint-disable import/no-anonymous-default-export */
import React from "react";
import { Container, Spinner } from "react-bootstrap";
import useJoinScheduledEvent from "./useJoinScheduledEvent";
import "./JoinScheduledEvent.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft} from "@fortawesome/free-solid-svg-icons";
import HmsQuestionModal from "./_components/HmsQuestionModal";
import JoinedScreen from "./_components/JoinedScreen";
import AssessmentHeader from "../AssessmentHeader";

export default (props) => {
  const {
    loading,
    formData,
    formErrors,
    isInviteeJoined,
    peers,
    isLocalAudioEnabled,
    isLocalVideoEnabled,
    hmsRoomDetail,
    brodacastMessages,
    showMessages,
    messageForm,
    modalOpen,
    hmsRoomQuestions,
    hmsQuestionForm,
    user,
    displayRejoinScreen,
    joineesNames,

    screenShareOn,
    presenter,
    localScreenShared,
    screenShareVideoTrack,
    skills,
    hmsRoomLoading,
    onFormInputChange,
    onJoinClick,
    onCallEndClick,
    toggleAudioClick,
    toggleVideoClick,
    onBackClick,
    navigateHome,
    sendBroadCastMessage,
    onShowMessagesClick,
    onMessageFormChange,
    handleModalOpen,
    onHmsQuestionFormChange,
    onHmsQuestionCreateClick,
    onRejoinClick,
    onQuestionRatingChange,
    onEndInterviewClick,
    onScreenShareClick,
    onDeleteHmsQuestion,
    onEditQuestionClick,
  } = useJoinScheduledEvent(props);

  return (
    <>
    <AssessmentHeader/>
      <div className="notifications-wrapper join-schedule-event">
        <Container>
          {displayRejoinScreen ? (
            <div className="join-events-screeen text-center">
              <div className="inner">
                <div className="heading">
                  <img src={"/assets/images/goodbye.png"} alt="wave hand" />
                  <h2 className="my-3"> You left the room </h2>
                </div>
                <div className="text-center mx-auto mb-4">
                  Left by mistake?
                  <span
                    className="cursor-pointer text-primary font-weight-semi ml-1"
                    onClick={onRejoinClick}
                  >
                    Rejoin
                  </span>
                </div>

                  <button
                    className="btn btn-danger w-100"
                    onClick={onEndInterviewClick}
                  >
                    End Interview
                  </button>
              </div>
            </div>
          ) : (
            <div>
              {!isInviteeJoined ? (
                <div className="join-events-screeen">
                  <div className="inner">
                    {loading ? (
                      <div className="p-5 text-center">
                        <Spinner animation="border" variant="primary" />
                      </div>
                    ) : (
                      <div>
                        <div className="heading">
                          <h2 className="mb-2">
                            {joineesNames[0]} meet with {" "}
                            {joineesNames[1]}
                          </h2>
                        </div>
                        <div className="display-name">
                          <div className="candidate-info">
                            <span className="bg-primary text-white candidate-initials d-flex align-items-center justify-content-center mx-auto">
                              {user?.user && user.user?.full_name
                                ? user?.user && user.user?.full_name[0]
                                : hmsRoomDetail?.name && hmsRoomDetail.name[0]}
                            </span>
                          </div>

                          <div className="form-wrapper">
                            <p className="font-weight-medium text-dark">Type your name and join </p>
                            <div className="">
                              <input
                                type="text"
                                className="form-control h-auto border-radius-10"
                                placeholder="Enter your name"
                                name="name"
                                defaultValue={formData?.name}
                                onChange={onFormInputChange}
                              />
                            </div>
                            <button
                              className="btn btn-primary border-radius-10 w-100 h-100 mt-3"
                              onClick={() => {
                                onJoinClick();
                              }}
                            >
                              {hmsRoomLoading ?
                                <Spinner variant="white" /> :
                                "Join Now"
                              }
                            </button>
                          </div>
                          <p
                            className="text-center mt-3 cursor-pointer"
                            onClick={onBackClick}
                          >
                            <FontAwesomeIcon icon={faArrowLeft} className="mr-2"/> Back
                          </p>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              ) : (
                <JoinedScreen
                  peers={peers}
                  user={user}
                  hmsRoomDetail={hmsRoomDetail}
                  hmsRoomQuestions={hmsRoomQuestions}
                  handleModalOpen={handleModalOpen}
                  toggleAudioClick={toggleAudioClick}
                  toggleVideoClick={toggleVideoClick}
                  isLocalAudioEnabled={isLocalAudioEnabled}
                  isLocalVideoEnabled={isLocalVideoEnabled}
                  onShowMessagesClick={onShowMessagesClick}
                  showMessages={showMessages}
                  brodacastMessages={brodacastMessages}
                  sendBroadCastMessage={sendBroadCastMessage}
                  messageForm={messageForm}
                  onMessageFormChange={onMessageFormChange}
                  onCallEndClick={onCallEndClick}
                  onQuestionRatingChange={onQuestionRatingChange}
                  //screen share
                  localScreenShared={localScreenShared}
                  screenShareOn={screenShareOn}
                  presenter={presenter}
                  screenShareVideoTrack={screenShareVideoTrack}
                  onScreenShareClick={onScreenShareClick}
                  onDeleteHmsQuestion={onDeleteHmsQuestion}
                  onHmsQuestionCreateClick={onHmsQuestionCreateClick}
                  onEditQuestionClick={onEditQuestionClick}
                  joineesNames={joineesNames}
                />
              )}

              {formErrors?.error && <p>{formErrors?.error}</p>}
            </div>
          )}
        </Container>
      </div>

      <HmsQuestionModal
        modalOpen={modalOpen}
        handleModalOpen={handleModalOpen}
        onHmsQuestionFormChange={onHmsQuestionFormChange}
        hmsQuestionForm={hmsQuestionForm}
        onHmsQuestionCreateClick={onHmsQuestionCreateClick}
        skills={skills}
      />
    </>
  );
};
